const BASE_URL = process.env.REACT_APP_APIBASE;

// for setting profile
export const USER_PROFILE_DATA = "/staff_api/profile";

//for staff
export const UPDATE_VEHICLE_DETAILS = `${BASE_URL}/staff_api/resubmit_vehcile_details`;
export const SUBMIT_EMPLOYEE_COMPLAINT_FORM = `${BASE_URL}/complaint_module/submit_complaint_form`;
export const SUBMIT_TIME_SHEET_COMMENT = `${BASE_URL}/staff_api/submit_invoice`;
export const SUPPORT_WORKER_TIME_SHEET = `${BASE_URL}/staff_api/get_contractor_invoices`;
export const REFINE_NOTES_TEXT = `${BASE_URL}/staff_api/refine_text`;
export const EMP_SUBMIT_HAZARD = `${BASE_URL}/staff_api/hazard_report_submit`;
export const MEDICATION_PRN_GET = `${BASE_URL}/staff_api/get_participant_prn`;
export const MEDICATION_SUBMIT_EMP = `${BASE_URL}/staff_api/submit_medicine_report`;
export const EMP_MEDICINES_LIST = `${BASE_URL}/staff_api/get_medicines_for_report`;
export const TODAYS_MEDICATION_LIST = `${BASE_URL}/staff_api/get_today_medicine_times`;
export const MED_REPORT_SUBMIT = `${BASE_URL}/staff_api/submit_medicine_report`;
// export const EMP_MEDICATION_DETAILS = `${BASE_URL}/staff_api/get_participant_medicine_details`
export const EMP_MEDICATION_DETAILS = `${BASE_URL}/staff_api/get_medicine_details`;
export const EMP_REMOVE_SWITCH_ACC = `${BASE_URL}/staff_api/remove_account`;
export const ACCOUNT_SWITCH = `${BASE_URL}/staff_api/admin_switch_account`;
export const SWITCHABLE_ACCOUNT_LIST = `${BASE_URL}/staff_api/added_accounts`;
export const CANCELING_OPEN_SHIFT = `${BASE_URL}/staff_api/cancel_shift_request`;
export const REQUESTED_OPEN_SHIFT_LIST = `${BASE_URL}/staff_api/get_request_shifts_data`;
export const OPEN_SHIFT_REQUEST = `${BASE_URL}/staff_api/request_for_shift`;
export const EMP_OPEN_SHIFT_LIST = `${BASE_URL}/staff_api/get_openshifts`;
export const EMP_AVAILABILITY_LIST = `${BASE_URL}/staff_api/get_emp_availability_chart`;
export const EMP_AVAILABILITY_ADD = `${BASE_URL}/staff_api/day_availability`;
export const EMP_UPDATE_AVAILABILITY = `${BASE_URL}/staff_api/update_emp_availability`;
export const EMP_SHIFT_START = `${BASE_URL}/staff_api/shift_start_clockin`;
export const EMP_SHIFT_END = `${BASE_URL}/staff_api/shift_end_clockout`;
export const EMP_RESEND_OTP = `${BASE_URL}/staff_api/resend_otp`;
export const POST_EMP_VERIFY_OTP = `${BASE_URL}/staff_api/otp_verification`;
// export const POST_EMP_LOGIN = `${BASE_URL}/staff_api/login_staff`;
export const POST_EMP_LOGIN = `${BASE_URL}/admin_login/login`;
export const EMP_UPLOAD_FILE_TO_FOLDER = `${BASE_URL}/staff_api/add_documents_by_emp`;
export const EMP_FETCH_MY_FILES = `${BASE_URL}/staff_api/get_participant_folder_files`;
export const EMP_FETCH_MY_FOLDER = `${BASE_URL}/staff_api/get_participant_assign_folder`;
export const FETCH_MY_SHIFTS = `${BASE_URL}/staff_api/get_shift_roaster_data`;
export const PROGRESS_NOTE_TILES_SAVE = `${BASE_URL}/staff_api/tiles_modal`;
export const PROGRESS_NOTE_SAVE = `${BASE_URL}/staff_api/submit_progress_notes`;
export const CLICK_ON_TRAINING_DOC_DOWNLOAD = `${BASE_URL}/staff_api/dawnload_training_link_doc`;
export const TRAINING_TERMS_CONFIRMATION = `${BASE_URL}/staff_api/confirmation_training_doc`;
export const EMPLOYEE_POLICIES = `${BASE_URL}/staff_api/get_privacy_policy`;
export const SUBMIT_EMPLOYEE_INCIDENT_FORM = `${BASE_URL}/staff_api/submit_incident_form`;
export const INCIDENT_FORM_QUESTIONS = `${BASE_URL}/staff_api/incident_question`;
export const UPLOAD_STAFF_TRAINING_CERT = `${BASE_URL}/staff_api/upload_training_documents`;
export const GET_STAFF_TRAININGS_LIST = `${BASE_URL}/staff_api/get_training_links`;
export const NOTIFY_ADMIN_FOR_SUBMITION_OF_DOCS = `${BASE_URL}/staff_api/notify_admin`;
export const GET_UPLOADED_DOC_STATUS = `${BASE_URL}/staff_api/get_uploaded_documents`;
export const GET_EMPLOYEE_DOC = `${BASE_URL}/staff_api/document_required`;
export const UPLOAD_REQ_EMPLOYEE_DOCS = `${BASE_URL}/staff_api/upload_sign_documents`;
export const UPLOAD_OPTIONAL_EMPLOYEE_DOCS = `${BASE_URL}/staff_api/other_document_upload`;
export const UPLOAD_VEHICLE_EMPLOYEE_DOCS = `${BASE_URL}/staff_api/add_personal_vehicle`;
export const EMPLOYEE_ATTACHEMENTS = `${BASE_URL}/staff_api/task_attachments_by_employee`;
export const ASSIGN_TASK_DATA_STAFF = `${BASE_URL}/staff_api/staff_assign_task_data`;
export const TASK_ID_DETAIL_STAFF = `${BASE_URL}/staff_api/staff_task_data_get`;
export const GET_PARTICIPANT_DETAILS = `${BASE_URL}/staff_api/staff_participent_details`;
export const GET_PROGRESS_NOTES = `${BASE_URL}/staff_api/staff_service_progress_notes_check`;
export const GET_SERVICE_ITEM_DETAILS = `${BASE_URL}/staff_api/staff_service_item_details`;
export const LOGOUT_STAFF = `${BASE_URL}/staff_api/log_out_staff`;
export const STAFF_FORGET_PASS = `${BASE_URL}/staff_api/forgot_password`;
export const STAFF_FORGET_PASS_OTP = `${BASE_URL}/staff_api/reset_password`;
export const GET_PROGRESS_NOTE_BY_ID = `${BASE_URL}/staff_api/edit_get_progress_notes`;
export const UPDATE_PROGRESS_NOTE_BY_STAFF = `${BASE_URL}/staff_api/testing_update_progress_notes`;
export const POST_CLOCKIN_TIME_STAFF = `${BASE_URL}/staff_api/staff_clock_in_records`;
export const POST_TIMMINGS_DATA = `${BASE_URL}/staff_api/medical_required_times`;
// export const POST_STAFF_ACTION_DATA = `${BASE_URL}/staff_api/task_accept_and_reject`
export const POST_STAFF_ACTION_DATA = `${BASE_URL}/staff_api/roster_shift_accept_and_reject`;
export const UPDATE_ADD_COMMENT = `${BASE_URL}/staff_api/update_progress_notes`;
export const POST_INICIDENT_FORM = `${BASE_URL}/staff_api/incident_report_submit`;
export const TASK_TIME_OUT = `${BASE_URL}/staff_api/set_time_out`;
export const APPROVE_SUBMIT = `${BASE_URL}/staff_api/update_clock_out_time`;
export const EMPLOYEE_TOKEN = `${BASE_URL}/`;
export const AWAY_PARTICIPANT = `${BASE_URL}/staff_api/participant_away_enable `;

//for admin

// INTEGRATION
export const SAVE_XEROX_CODE = "/xero_integration/exchangeToken";

// LOCATION
export const VISITOR_UPDATE = "/staff_api/update_visitor_register";
export const VISITOR_FILE_REMOVE = "/staff_api/remove_attachment";
export const CONTRACTOR_STATUS_CHANGE = "/location_register/update_other_person_status";
export const VISITOR_ADD = "/staff_api/visitor_entry_form";
export const UPDATE_CONTRACTOR = "/location_register/update_other_person_data";
export const UPDATE_SERVICE = "/location_register/update_service_data";
export const UPDATE_LOCATION = "/location_register/update_sil_sda_home";
export const VISITOR_LIST = "/staff_api/get_visitor_list";
export const LOCATION_SERVICE_LIST = "/location_register/get_services_list";
export const ADD_LOCATION_SERVICE = "/location_register/service_form";
export const CONTRACTOR_LIST = "/location_register/get_other_persons_list";
export const ADD_CONTRACTOR = "/location_register/other_person_add_form";

// PROGRESS NOTE TEMPLATE
export const PROGRESS_NOTE_TEMPLATES = "/notes_template/get_templates_list";
export const PROGRESS_NOTE_CREATE = "/notes_template/progress_notes_template";
export const PROGRESS_NOTE_UPDATE = "/notes_template/update_template_fields";
export const PROGRESS_NOTE_REMOVE = "/notes_template/delete_template";

// ROLE ACCESS
export const GET_ASSIGN_TEMPLATE = "/categorize_feature/get_category_data";
export const ASSIGN_ACCESS = "/categorize_feature/assign_category";
export const ROLE_ACCESS_LIST = "/categorize_feature/get_category_list";
export const UPDATE_ROLE_ACCESS = "/categorize_feature/update_category";
export const ADD_ROLE_ACCESS = "/categorize_feature/create_category";

// HAZARD REPORT
export const HAZARD_REPROTS_DATA = "/admin_portal/get_hazard_report_data";
export const HAZARD_REPROTS_BY_LOCATION = "/admin_portal/get_location_hazard_report";
export const REVIEW_HAZARD_REPROTS = "/admin_portal/review_hazard";
export const HAZARD_EMAIL_SAVE = "/admin_portal/store_hazard_emails";

// TEAM (sub-admin & manager)
export const GET_TEAM_DASHBOARD_LIST = "/managers_admin_tasks/get_manager_admin_shift_roaster_data";
export const TEAM_NOTIFY_ACTION = "/shift_roster/employee_shift_accept_and_reject";
export const TEAM_START_SHIFT = "/managers_admin_tasks/shift_start_clockin";
export const TEAM_END_SHIFT = "/managers_admin_tasks/shift_end_clockout";
export const GET_TEAM_TASK_LIST = "/managers_admin_tasks/staff_assign_task_data";
export const TASK_DETAILS_TEAM = "/managers_admin_tasks/staff_task_data_get";
export const ENTER_TEAM_NOTES = "/managers_admin_tasks/admin_manager_enter_progre_notes";
export const SEND_FILES_FOR_TASK = "/managers_admin_tasks/task_attachments_by_admin_manager";

// BULK BILLING
export const GET_BULK_BILLES = "/bulk_billing/bulk_billing_get_data";

// TEMPLATES
export const TEMPLATE_DELETE = "/template/delete_template_files";
export const TEMPLATE_ADD = "/template/add_template_files";
export const TEMPLATE_GET = "/template/get_added_templates_files";

// PRESCRIBER
export const PRESCRIBER_LIST_FOR_TASK = "/medication/show_prescriber_list";
export const PRESCRIBER_LIST = "/medication/gte_prescriber_data";
export const PRESCRIBER_ADD = "/medication/add_prescriber";
export const PRESCRIBER_UPDATE = "/medication/update_prescriber_data";
export const PRESCRIBER_DELETE = "/medication/delete_prescriber";

// MEDICATION
export const MEDICATION_CATEGORIES_LIST = "/medication/get_category_lists";
export const CREATE_CATEGORY_MEDICINE = "/medication/add_medicine_category";
export const UPDATE_PART_MED = "/medication/update_participant_medicine_profile_data";
export const CATEGORY_MEDICINES_LIST = "/medication/get_added_medicine";
export const CREATE_MEDICINE = "/medication/add_medicine";
export const UPDATE_MEDICINE = "/medication/update_medicine_data";
export const DELETE_MEDICINE = "/medication/delete_medicine";
export const MEDICINE_DETAILS = "/medication/edit_get_medicine_data";
export const MED_DROP_DOWN_LIST = "/medication/get_medicine_details";
export const TASK_PART_MED_DETAILS = "/medication/get_medicine_list_for_task";
export const PARTICIPANT_MED_DETAILS = "/medication/edit_get_participant_medicine_profile_data";
export const SAVE_PARTICIPANT_MED_DETAILS = "/medication/participant_medication_details";
export const MED_DOC_DELETE = "/medication/delete_medicine_document";
export const PART_MED_REMOVE = "/medication/remove_participant_medicine";
export const UPDATE_MED_PART_LIST = "/medication/update_participant_medicines";
export const MEDICATION_REPORT_TASK = "/medication/get_task_medicine_report";
export const PARTICIPANT_MED_LIST_ADD = "/medication/add_more_participant_medicine";
export const PARTICIPANT_MEDICATION_REPORT = "/participents/participant_medicine_report";
export const PART_MEDICINE_LOG_GET = "/logs/participant_medicine_log_data";
export const MEDICATION_LOG_GET = "/logs/medicine_logs";

// ADMINS
export const LIST_ADMINS = "/admin_portal/get_client_admin_list";

// SWITCH ACCOUNT
export const SWITCHABLE_ACCOUNTS_LIST_ADMIN = "/admin_portal/admin_added_accounts";
export const SWITCHABLE_ACCOUNTS_ADMIN = "/admin_portal/admin_switch_account";
export const SWITCHABLE_ACC_ADMIN_REMOVE = "/admin_portal/remove_admin_account";
export const ADD_SWITCH_ACCOUNT_ADMIN = "/admin_login/switch_account_login";

// LOGIN
export const SUPER_ADMIN_LOGIN = "/admin_login/super_admin_login";
export const LOGIN_REPORTS = "/admin_login/participant_login";
export const ADMIN_LOGIN = "/admin_login/login";

// NOTICE BOARD
export const CHECK_BOARD_ACTIVE = "/notice_board/check_notice_board_status";
export const NOTICE_BOARD_PASSWORD_RESET = "/notice_board/set_account_new_password";
export const NOTICE_BOARD_SLIDE_UPDATE = "/notice_board/update_controls";
export const NOTICE_BOARD_SLIDE_DELETE = "/notice_board/delete_notice";
export const NOTICE_BOARD_LOGIN = "/notice_board/notice_board_login";
export const ADD_BOARD_SLIDE = "/notice_board/notice_board_docs";
export const FETCH_BOARD_SLIDES = "/notice_board/get_notice_board_data";
export const BOARDS_LIST = "/notice_board/get_notice_board_accounts";
export const CREATING_NOTICE_BOARD = "/notice_board/create_notice_board_account";
export const DELETE_NOTICE_BOARD = "/notice_board/delete_notice_board_account";

// CHAT GPT
export const APPROVE_REPORT = "/chat_gpt/change_report_status";
export const TEXT_REFINING = "/staff_api/refine_text";
export const REPORT_GENERATE = "/participents/participant_full_day_report";
export const STORE_OPEN_AI_TEXT = "/chat_gpt/store_output";
export const OPEN_AI_PROGRESS_NOTES = "/chat_gpt/get_stored_output_notes";
export const OPEN_AI_REPORT_UPDATE = "/chat_gpt/update_stored_notes";
export const OPEN_AI_REPORT_DELETE = "/chat_gpt/delete_generated_notes";
export const OPEN_AI_REPORT_LOGS = "/logs/chat_gpt_logs";
export const REPORT_ATTACH_LIST = "/participents/get_attachments";
export const SAVE_ATTACH_REPORT_LIST = "/participents/save_selected_attachments";
export const DELETE_ATTACH_REPORT = "/participents/delete_attachments";
export const PARTICIPANT_TASK_REPORT = "/chat_gpt/get_refine_note";

// SUPER ADMIN
export const SUPERADMIN_MANAGER_UPDATE = "/login/update_manager_account";
export const WORKSPACE_DETAILS_UPDATE = "/login/update_workspace_data";
export const WORKSPACE_DETAILS = "/login/edit_get_workspace_data";
export const GET_ADMIN = "/login/get_admin_data";
export const POST_ADD_ADMIN = "/login/add_admin";
export const DELETE_ADMIN = "/login/delete_admin";
export const POST_ADD_MANAGER = "/login/add_manager";
export const WORKSPACE_USER_DELETE = "/login/delete_manager_account";
export const ADMIN_ACCOUNT_STATUS_TOGGLE = "/login/deactivate_manager_account";

// TASK
export const GET_TASK_LOGS = "/logs/get_task_log_data";
export const RATE_TASK_NOTES = "/staff/task_rating";
export const SEND_RATE_TASK_EMAIL = "/emails_setting/rating_notify";

// SHIFT
export const CANCEL_SHIFT_ADMIN = "/staff_api/cancel_shift";
export const DELETE_SHIFT = "/shift_roster/delete_roster_shift";
export const SHIFT_UPDATE = "/shift_roster/update_shifts";
export const FETCH_SHIFTS_LIST = "/shift_roster/get_shift_roster_data";
export const ADD_EMPLOYEE_SHIFT = "/shift_roster/add_shift";
export const GET_SHIFT_LOGS = "/logs/get_shift_roster_log_data";

// EMPLOEE
export const EMPLOYEE_PROFILE_COPY = "/product/copy_staff";
export const GENERATE_TIME_SHEET = "/invoices/get_timesheetdata_for_invoice";
export const GET_ADMIN_TIMESHEET_LIST = "/invoices/get_created_invoices";
export const SEND_TIME_SHEET_TO_SUPPORT_WORKER = "/invoices/store_invoice_data";
export const RE_SUBMIT_TIME_SHEET = "/invoices/re_submit_invoice";
export const REMOVE_TIME_SHEET = "/invoices/delete_contractor_invoice";
// export const GET_EMPLOYEE_RATING_REPORT = "/rating_task/export_emp_task_rating";
export const GET_EMPLOYEE_RATING_REPORT = "/rating_module/export_emp_task_rating";

// EMAIL
export const GETING_STORED_EMAILS = "/emails_setting/get_stored_emails";
export const ADDRESS_BOOK_LIST = "/emails_setting/get_email_adderss_book";
export const ADDRESS_BOOK_REMOVE_EMAIL = "/emails_setting/remove_address_email";

// PARTICIPANT
export const GET_MYNDIS_GOAL = "/participents/get_myndis_goal";
export const ADD_STATUS_REMARK = "/participents/add_remarks";
export const PARTICIPANT_STATUS_LOG = "/participents/get_active_inactive_history";
export const PARTICIPANT_DETAILS_FOR_TASK = "/participents/participant_details";
export const PARTICIPANTS_ASSIGNEES = "/participents/participant_supportworker_list";
export const CHANGE_TASK_STATUS = "/staff/change_task_status";
export const OPEN_SHIFT_DELETE = "/shift_roster/delete_open_shift";
export const OPEN_SHIFT_REQUESTS = "/shift_roster/get_request_list";
export const SHIFT_REQUEST_ACCEPT = "/shift_roster/accept_request";
export const OPEN_SHIFT_UPDATE = "/shift_roster/update_open_shift_data";
export const OPEN_SHIFT_ADD = "/shift_roster/create_open_shift";
export const OPEN_SHIFT_LIST = "/shift_roster/get_openshifts_data";
export const TASK_DOCUMENT_DELETE = "/staff/delete_task_documents";
export const STAFF_DOC_DELETE = "/staff/delete_staff_documents";
export const DELETING_PARTICIPANT_DISCRIPTION = "/product/delete_participant_description";
export const DELETING_PARTICIPANT_DOCUMENT = "/participents/delete_participant_documents";
export const FOLDER_RENAME = "/participents/update_folder_name";
export const USER_VALIDITY = "/admin_login/check_manager_id";
// export const USER_VALIDITY = "/login/check_profile"
export const GET_MY_AVAILABILITY = "/staff/employee_day_availability_calender";
export const DELETE_FILE_SERVICE_RECORD_BY_ID = "/vehicle/delete_attachment";
export const SERVICE_RECORD_LOGS = "/logs/vehicle_service_logs";
export const ADD_FILE_SERVICE_RECORD_BY_ID = "/vehicle/upload_files";
export const GET_SERVICE_RECORD_BY_ID = "/vehicle/edit_get_service_record";
export const ADDING_VEHICLE_FILE = "/vehicle/add_vehicle_attachments";
export const DELETING_VEHICLE_FILE = "/vehicle/delete_document";
export const UPDATING_SERVICE_RECORD = "/vehicle/update_service_records";
export const DELETING_SERVICE_RECORD = "/vehicle/delete_service_records";
export const ADDING_SERVICE_RECORD = "/vehicle/add_service_records";
export const SERVICE_RECORD_LIST = "/vehicle/get_vehicle_service_records";
export const ADMIN_RESEND_OTP = "/admin_login/resend_otp";
export const OTP_VERIFY = "/admin_login/otp_verification";
export const DELETE_USER_FOLDER = "/participents/delete_folder";
export const REMOVING_FOLDER_USER = "/participents/release_employee";
export const UPDATING_FOLDER_PERMISSION = "/participents/update_permission";
export const FOLDER_ASSIGNED_MEMBERS = "/participents/get_folder_assign_employees";
export const ASSIGNING_FOLDERS = "/participents/assign_participants_folder";
export const DELETE_FOLDER_DOCS = "/participents/delete_documents";
export const UPLOAD_FILE_TO_FOLDER = "/participents/add_participant_documents";
export const FETCH_MY_FILES = "/participents/get_folder_files";
export const FETCH_MY_FOLDER = "/participents/get_participant_folders";
export const CREATE_MY_FOLDER = "/participents/create_participant_folders";
export const FREE_EMAIL_NOTIFICATIONS = "/notification/free_emails_notification";
export const FREE_MY_NOTIFICATIONS = "/notification/free_notification";
export const GET_NOTIFICATIONS = "/notification/notification_alert";
export const EMAIL_SIGN_ADD = "/emails_setting/store_email_signature";
export const MAIL_READ = "/emails_setting/update_new_count_value";
// export const GET_INBOX_MAILS = "/emails_setting/test_get_emails_data"
export const GET_INBOX_MAILS = "/emails_setting/test_get_emails_data";
export const SEND_EMAIL = "/emails_setting/send_custom_emails";
export const REPLY_EMAIL = "/emails_setting/reply_to_email";
export const PARTICIPANT_EMAIL_FETCH = "/participents/get_participant_emails";

export const LOCATION_SKIP = "/admin_portal/skip_location";
export const MANAGER_TO_ADMIN_LOGIN = "/admin_portal/back_to_admin_account";
export const MANAGER_LOGIN = "/admin_portal/login_manager_account";
export const LOCATION_DELETE = "/admin_portal/delete_location";
export const FETCH_PARTICIPANT_LOCATION = "/admin_portal/get_participant_location";
export const MANAGER_UPDATE = "/admin_portal/update_manager_location";
export const EMPLOYEE_BY_LOCATION_LIST = "/admin_portal/get_staff_by_location";
export const PARTICIPANT_BY_LOCATION_LIST = "/admin_portal/get_participant_by_location";
export const GET_DETAILS_MANGER = "/admin_portal/get_manager_data";
export const ASSIGNING_LOCATIONS = "/admin_portal/assign_locations";
export const FETCH_MANAGERS = "/admin_portal/get_manager_list";
export const ALL_AVAILABLE_LOCATION_LIST = "/admin_portal/location_list"; // for all list
export const FETCH_LOCATIONS = "/admin_portal/location_active_list"; // for active list
export const ADDING_LOCATIONS = "/admin_portal/add_location";
export const DELETE_PRIVACY_POLICY_DOC = "/privacy_policy/delete_privacy_policy";
export const UPLOAD_PRIVACY_POLICY_DOC = "/privacy_policy/upload_policy_doc";
export const PRIVACY_POLICY_LIST = "/privacy_policy/get_privacy_policy_doc";
export const ADD_NEW_RISK_ASSESSMENT_FORM = "/risk_assessment_register/add_risk_assessment_doc";
export const RISK_ASSESSMENT_LIST = "/risk_assessment_register/get_all_risk_assessment_doc";
export const RISK_ASSESSMENT_STATUS_UPDATE = "/risk_assessment_register/update_status_risk_assessment_doc";
export const RISK_ASSESSMENT_LIST_DELETE = "/risk_assessment_register/delete_risk_assessment_doc";

//Rating Dashboard
export const GET_EMPLOYEE_RATING_DASHBOARD_TASK = "/rating_module/rating_dashboard";

// INCIDENT REPORT
export const ARRANGE_INCIDENT_QUES_ORDER = "/incident_report/rearrange_order";
export const LOGS_INCIDENT_REPORT = "/logs/incident_answers_log";
export const SEND_EMAIL_FOR_INCIDENT_REPORT = "/incident_report/notify_participant_relatives";
export const FETCH_ALL_INICIDENT_FORM_DATA = "/incident_report/preview_incident_form";
export const ADMIN_REVIEW_INCIDENT_FORM = "/incident_report/admin_incident_form_submit";
export const REVIEW_INCIDENT_FORM = "/incident_report/get_task_incident_form";
export const INICIDENT_FORM_QUES_UPDATE = "/incident_report/edit_question";
export const DELETE_QUES_INCIDENT = "/incident_report/delete_question";
export const GET_ADDED_INCIDENT_FORM_QUESTIONS = "/incident_report/get_added_question";

export const EXPORT_SHIFT_REPORT = "/shift_roster/export_shift_roster";
export const EXPORT_EMP_TASK_DATA_TO_EXCEL = "/progress_notes/task_export_by_staff_id";
export const EXPORT_PART_TASK_DATA_TO_EXCEL = "/progress_notes/task_export_by_participant_id";
export const EXPORT_TASK_DATA_TO_EXCEL = "/progress_notes/task_export_by_task_date_range";
// export const UPDATE_TRAINING_LINK = `/staff/edit_training_links`
export const UPDATE_TRAINING_LINK = "/training_links/update_training_links";
export const TRAINING_ASSIGN = "/training_links/assign_training_links";
export const DELETE_TRAINING_LINK = "/training_links/delete_links";
export const GET_TRAINING = "/training_links/get_training_links";
export const ADD_NEW_TRAINING = "/training_links/upload_training_links";
export const EXP_DOCS_LIST = "/staff/expired_documents";
export const NOTIFY_EMPLOYEE_DOCS = "/staff/notify_employee";
export const EMPLOYEE_DOC_APPROVAL = "/staff/approve_documents";
export const EMPLOYEE_VEHICLE_DOC_APPROVAL = "/staff/approve_vehicles_docs";
export const EMPLOYEE_PROFILE_DOCUMENTS = "/staff/get_emp_uploaded_documents";
export const VEHICLE_TRAVEL_HISTORY = "/vehicle/vehicle_travel_history";
export const VEHICLE_LOGS = "/logs/vehicle_logs";
export const PROGRESS_NOTES_BY_ADMIN = "/staff/progress_notes_by_admin";
// export const UPDATE_INCIDENT_FORM_ADMIN = `/incident_report/update_incident_form`
export const UPDATE_INCIDENT_FORM_ADMIN = "/incident_report/add_incident_questions";
export const GET_INVOICE_DETAILS_DATA = "/invoices/generated_invoice_data";
export const GET_INVOICE_LIST_DATA = "/invoices/get_invoice_data";
export const SEND_DATA_INVOICE = "/invoices/invoice";
export const CHANGE_PART_STATE = "/participents/change_participant_state";
export const CHANGE_STAFF_STATE = "/login/change_staff_state";
export const EDIT_VEHICLE_DETAILS_ADMIN = "/staff/edit_staff_vehicle_records";
export const CLOCKIN_RESTRICTION = "/staff/clock_in_validation";
export const DELETE_TASK_DESCRIPTION = "/login/delete_description";
export const UPDATE_TASK_DESCRIPTION = "/login/update_description";
export const ADMIN_UPLOAD_INCIDENT_FORM = "/incident_report/upload_updated_incident_report";
export const GET_INVOICES = "/invoices/invoice_data";
export const DELETE_MULTIPLE_TASKS = "/staff/delete_multiple_task";
export const INSERT_STAFF_TIMMINGS = "/staff/emp_clock_in_out_by_admin";
export const UPDATE_STAFF_TIMMINGS = "/staff/update_clock_in_time";
export const EDIT_COMPANY_PROFILE = "/login/company_logo";
export const FETCH_OLD_INCIDENT_FORM_LIST = "/incident_report/incident_report";
export const GET_INCIDENT_FORMS_LIST = "/incident_report/get_employee_submited_form";
export const APPROVE_TASK = "/login/approve_time_out_task";
export const VEHICLE_LIST = "/vehicle/vehicle_list";
export const VEHICLE_DETAILS = "/vehicle/edit_vehicle_get_data";
export const VEHICLE_UPDATE = "/vehicle/update_vehicle";
export const ADD_VEHICLE = "/vehicle/add_vehicle";
export const DELETE_VEHICLE = "/vehicle/delete_vehicle_data";
export const POST_EDIT_PROFILE = "/login/admin_profile_picture";
export const UPATE_PART_PRO_PIC = "/participents/participant_profile_picture";
export const LOGIN_API = `${BASE_URL}/admin_login/login`;
export const FORGET_PASS_EMAIL_COMPANY = `${BASE_URL}/admin_login/forgot_password`;
export const FORGET_PASS_OTP = `${BASE_URL}/admin_login/reset_password`;
export const POST_ADD_COMMENT = "/staff/comment_by_admin";
export const HANDLE_SHOW_HIDE = "/participents/document_restriction";
export const UPDATE_ADMIN_NOTE = "/staff/admin_update_progress_notes";
export const POST_TIME_ZONE = "/login/add_time_zone";
export const GET_DEMO_DATA = "/product/drop_dawn_data";
export const GET_DROP_DOWN_LIST_DATA = "/product/drop_dawn_data";
export const POST_ADD_PARTICIPANT = "/product/add_client_data";
export const PART_CAL_DATA_BY_ID = "/participents/get_participent_task_calender";
export const STAFF_CAL_DATA_BY_ID = "/staff/get_staff_task_calender";
// export const GET_ALL_PARTICIPANTS = `/product/get_client_data`
export const GET_ALL_PARTICIPANTS = "/admin_portal/get_client_data";
// export const GET_ALL_STAFF = `/product/staff_list`
export const GET_ALL_STAFF = "/admin_portal/staff_list";
export const GET_STAFF_BY_ID = "/staff/edit_staff_get_data";
export const POST_ADD_STAFF = "/product/add_staff";
export const DELETE_TRAINING_CERTIFICATE = "/staff/delete_training_certificate";
export const POST_STAFF_DOCS = "/product/add_employee_documents";
export const GET_STAFF_BY_EMAIL = "/product/staff_data";
export const GET_LANG_TIME = "/product/time_zone";
export const GET_PARTICIPANT_DETAIL = "/product/edit_client_get_data";
export const DELETE_PARTICIPANT = "/participents/delete_client_data";
export const GET_SERVICE_LIST = "/product/indus_services_list";
export const DELETE_STAFF = "/staff/delete_staff_data";
export const POST_PARTICIPANT_DOC = "/participents/document_upload";
export const GET_PARTICIPANT_DOCS = "/participents/get_participent_documents";
export const POST_UPDATE_PARTICIPANT = "/product/update_client_data";
export const POST_SERVICE_DATA = "/services/add_services";
export const GET_SERVICE_DATA = "/services/get_services_data";
export const POST_UPDATE_SERVICE = "/services/update_service_data";
export const GET_SERVICEID = "/services/edit_service_get_data";
export const POST_DELETE_SERVICE = "/services/delete_service_data";
export const GET_ACTIVE_SERVICES = "/services/get_services_by_state_active";
export const POST_UPDATE_STAFF = "/product/update_staff_data";
// export const GET_EVENTS = `/staff/get_assigned_tasks`
export const GET_EVENTS = "/admin_portal/get_assigned_tasks";
export const GET_EVENTS_LIST = "/admin_portal/get_assigned_tasks_list";
// export const GET_EVENTS = `/admin_portal/test_get_assigned_tasks`
// export const ADD_NEW_EVENT = `/staff/assign_task_to_staff`
export const ADD_NEW_EVENT = "/staff/assign_task_to_staff_tiles";
export const DELETE_EVENT = "/staff/delete_assigned_services";
// export const UPDATE_EVENT = `/staff/update_assign_task_staff`
export const UPDATE_EVENT = "/staff/update_assign_task_staff_tiles";
export const GET_TASK_DETAILS = "/staff/edit_get_assign_task_staff";
export const TASK_EXPORT_DATA = "/progress_notes/task_excel_data_export";
export const POST_TASK_DOC = "/staff/document_upload";
export const GET_TASK_DOC = "/staff/get_task_documents";
export const GET_TASK_LIST = "/admin_portal/staff_service_assign_data";

// COMPLAINT REPORT

export const ARRANGE_COMPLAINT_QUES_ORDER = "/complaint_module/rearrange_order";
export const ADD_COMPLAINT_QUESTION = "/complaint_module/add_complaint_questions";
export const GET_ADDED_COMPLAINT_QUESTION = "/complaint_module/get_added_question";
export const DELETE_COMPLAINT_QUESTION = "/complaint_module/delete_question";
export const EDIT_COMPLAINT_QUESTION = "/complaint_module/edit_question";
export const GET_EMPLOYEE_COMPLAINT_FORM = "/complaint_module/submit_complaint_form";
export const GET_COMPLAINT_REGISTER = "/complaint_module/complaints_register";
export const GET_COMPLAINT_FORM_DETAIL = "/complaint_module/get_complaint_form";
export const PREVIEW_COMPLAINT_FORM = "/complaint_module/preview_complaint_form";
export const REVIEW_COMPLAINT_FORM = "/complaint_module/admin_complaint_form_submit";

// FUNDING REPORT
export const GET_PARTICIPANT_FUNDING = "funding_module/get_participant_funding_data";
// MANAGER API`s

//Template`s APIs
//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
// export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//Mails
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//CALENDER
// export const UPDATE_EVENT = "/update/event";
// export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICE_DETAIL = "/invoice";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//TASKS
export const GET_TASKS = "/tasks";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";
